import { Dispatch, SetStateAction } from 'react'
import { DotProps } from './bottom-navigation/NavigationDot'

export type CarouselContextState = {
  onNextPress: () => unknown
  goToNext: () => unknown
  onPreviousPress: () => unknown
  goToPrevious: () => unknown
  onDotPress: (index: number) => unknown
  goTo: (index: number, dontAnimate?: boolean | undefined) => unknown
  currentIndex: number
  pages: number
  infinite: boolean
  onSlideChange: (index: number) => unknown
} & Required<Pick<DotProps, 'color'>>

export type CarouselContextType = {
  state: CarouselContextState
  setState: Dispatch<SetStateAction<CarouselContextState>>
}

export const DEFAULT_CONTEXT_VALUE: CarouselContextType = {
  state: {
    onNextPress: () => null,
    goToNext: () => null,
    onPreviousPress: () => null,
    goToPrevious: () => null,
    onDotPress: () => null,
    goTo: () => null,
    currentIndex: 0,
    pages: 0,
    infinite: true,
    onSlideChange: () => null,
    color: 'standard',
  },
  setState: () => {},
}
